module.exports = __webpack_public_path__ + "img/back_arrow.7eb17157.svg";